export const CompanyName = "ACES"
export const previewDateFormat = "DD-MM-YYYY"
export const APIDateFormat = "YYYY/MM/DD"
export const FilterAPIDateFormat = "YYYY-MM-DD"
export const BigPagination = 1000
